import React, {useState} from "react";
import {Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, MenuItem, Menu, ListItemIcon, ListItemText, List, ListItem, ListItemAvatar, Avatar} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CustomButton from "../../../core/components/ui/CustomButton";
import CustomClickableLabel from "../../../core/components/ui/custom-clickable-label.component";
import theme from "../../../core/components/layout/theme";
import moment from "moment";
import CustomStatusLabel from "../../../core/components/ui/custom-status-label.component";
import CustomListviewLoader from "../../../core/components/common/custom-listview-loader.component";
import CustomTable from "../../../core/components/common/custom-table.component";
import CustomModal1 from "../../../core/components/ui/custom-modal1.component";
import OrganizationCreateDriverComponent from "../../OrganizationPlugin/components/business-driver-component/organization-create-driver.component";
import {useNavigate} from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DevicesIcon from "@mui/icons-material/Devices";
import {useGuard} from "../../RBACPlugin";
import {permissions} from "../../../core/components/common/variables/static_variables";
import UpdateStatusDialog from "./update-driver-status.component";
import CreateDriverComponent from "./create-driver.component";

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string?.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name?.split(' ')[1] ? name.split(' ')[1][0] : ''}`,
  };
}

const CustomMenuPopperComponent = ({
  data,
  setAddDialogOpen,
  setUpdateDialogOpen,
  theme,
  customIconStyles,
  setSelectedAction
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleUpdateStatus = () => {
    setUpdateDialogOpen(true);
    setSelectedAction(data);
    handleClose();
  };

  const menuItems = [
    {
      icon: <VisibilityIcon fontSize="small" sx={{ color: theme.palette.primary.main }} />,
      label: "View Details",
      onClick: () => {
        navigate(`/driver/view?profile_uid=${data.profile_uid}&org_uid=${data.org_uid ? data.org_uid : ""}`);
        handleClose();
      }
    },
    {
      icon: <DevicesIcon fontSize="small" sx={{ color: theme.palette.primary.main }} />,
      label: "Update Status",
      onClick: handleUpdateStatus
    }
  ];

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{ style: { maxHeight: 300 } }}
      >
        {menuItems.map((item, index) => (
          <MenuItem
            key={index}
            onClick={item.onClick}
          >
            <ListItemIcon sx={customIconStyles}>{item.icon}</ListItemIcon>
            <ListItemText sx={{ ml: "-3px" }} primary={item.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

const ListDriverComponent = (props) => {
    const {headers, data, isMobile, breakpoints, loading} = props;

    const [open, setOpen] = useState(false);
    const [selectedDriver, setSelectedDriver] = useState();

    const [addDialogOpen, setAddDialogOpen] = useState(false);
    const [updateDialogOpen, setUpdateDialogOpen] = useState(false);
    const [selectedAction, setSelectedAction] = useState(null);

    const handleUpdateList = () => {
        setAddDialogOpen(false);
        setUpdateDialogOpen(false);
        // Optionally, you can trigger a refresh of the data here
    };

    return (
        <Paper sx={{width: "100%", overflow: "hidden"}}>
            {loading ? (
        <CustomListviewLoader />
      ) : (
          <CustomTable headers={headers}>
            {data?.length > 0 ? (
              data.map((row) => {
                const formattedCreatedAt = moment(row.created_at).format("MMMM DD YYYY, h:mm:ss a");
                return (
                  <TableRow key={row.id}>
                    <TableCell >
                        <List>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar {...stringAvatar(row?.user_info[0] ?  row?.user_info[0]?.firstname + " " + row?.user_info[0]?.lastname : row?.user_info?.firstname + " " + row?.user_info?.lastname)} />
                                </ListItemAvatar>
                                <ListItemText
                                  primary={
                                    row?.user_info?.[0]
                                      ? `${row.user_info[0].firstname} ${row.user_info[0].lastname}`
                                      : `${row?.user_info?.firstname || ""} ${row?.user_info?.lastname || ""}`
                                  }
                                  secondary={
                                    row?.user_info?.email ||
                                    row?.user_info?.[0]?.email ||
                                    ""
                                  }
                                />

                            </ListItem>
                        </List>
                    </TableCell>
                    <TableCell><CustomClickableLabel>{row.id_no}</CustomClickableLabel></TableCell>
                    <TableCell><CustomClickableLabel>{row.id_type}</CustomClickableLabel></TableCell>
                    <TableCell>{row.role}</TableCell>
                    <TableCell>{row.profile_type}</TableCell>
                    <TableCell><CustomStatusLabel label={row.status} /></TableCell>
                    <TableCell>{formattedCreatedAt}</TableCell>
                    <TableCell>
                      <CustomMenuPopperComponent
                        data={row}
                        setAddDialogOpen={setAddDialogOpen}
                        setUpdateDialogOpen={setUpdateDialogOpen}
                        theme={theme}
                        setSelectedAction={setSelectedAction}
                      />
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={headers.length} align="center">
                  No available account to display
                </TableCell>
              </TableRow>
            )}
          </CustomTable>
        )}

        <UpdateStatusDialog
            open={updateDialogOpen}
            setOpen={setUpdateDialogOpen}
            selectedAction={selectedAction}
        />
        </Paper>
    )
}

export default ListDriverComponent